var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('div',{staticStyle:{"font-size":"200px"}},[_vm._v("?")]),_vm._v("\n  The requested page was not found.\n")])}]

export { render, staticRenderFns }